import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetTeamsIntegration as GetTeamsIntegrationQuery} from 'nutshell-graphql-types';

import GET_TEAMS_INTEGRATION from '../queries/get-teams-integration.graphql';

export const useGetTeamsIntegration = () => {
    const {data, error, loading, refetch} = useQuery<GetTeamsIntegrationQuery, Record<any, any>>(
        GET_TEAMS_INTEGRATION,
        {
            fetchPolicy: 'cache-and-network',
        }
    );

    const loggedInUser = data ? data.loggedInUser : null;

    return {
        microsoftTeamsIntegration: loggedInUser && loggedInUser.microsoftTeamsIntegration,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading: loading,
        refetch,
    };
};
